import {
    required,
    numeric,
    email,
    max,
    min,
    confirmed
} from 'vee-validate/dist/rules'

import {
    extend,
    ValidationObserver,
    ValidationProvider,
    // setInteractionMode
} from 'vee-validate'

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
});

extend('email', {
    ...email,
});

extend('numeric', {
    ...numeric,
    message: '{_field_} must be numeric format',

});

extend('min', {
    ...min,
    message: 'The {_field_} must be {length} or more'
});

extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
});

extend('confirmed', {
    ...confirmed,
});

export default {
    components: {
        ValidationObserver,
        ValidationProvider
    }
}
